<template>
    <div></div>
</template>

<script>
    export default {
        name: 'redirect',

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted () {
            if (this.$store.state.authenticated) {
                this.$router.push({ name: 'app.dashboard' }).catch(err => { if (err) console.log(err.name || '') })
            }
        }
    }
</script>
